import { render, staticRenderFns } from "./TaxInvoiceForm.vue?vue&type=template&id=522fbd8e&scoped=true&"
import script from "./TaxInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxInvoiceForm.vue?vue&type=style&index=0&id=522fbd8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522fbd8e",
  null
  
)

component.options.__file = "TaxInvoiceForm.vue"
export default component.exports